class Dynamic_Group {
    static path = 'variables/dynamic-group';

    constructor(mutator) {
        this.addInput("Search", "no_inputs");
        this.addOutput("Group Found", "model,group");
        this.addOutput("Group Not Found", "");
        this.properties = {selected: '', modelProperties: window.triggerInfo.models['group']}

        this.addWidget("combo","",'',(v) => {
            this.properties.selected = v;
            if(v !== '') {
                if(v === 'Search By Group ID') {
                    this.title = 'Group from ID';
                    this.inputs[0].name = 'Group ID';
                    this.inputs[0].type = 'integer';
                    this.disconnectInput(0);
                } else if(v === 'Search By Partial Title') {
                    this.title = 'Group from Partial Title';
                    this.inputs[0].name = 'Title Contains';
                    this.inputs[0].type = 'string';
                    this.disconnectInput(0);
                } else if(v === 'Search By Exact Title') {
                    this.title = 'Group from Exact Title';
                    this.inputs[0].name = 'Title Is';
                    this.inputs[0].type = 'string';
                    this.disconnectInput(0);
                }
            } else {
                this.title = 'Dynamic Group'
                this.inputs[0].name = 'Search';
                this.inputs[0].type = 'no_inputs';
            }
            this.triggerSlot(0, v);
            this.triggerSlot(1, v);
        },{ property: "selected", values: ['Search By Group ID', 'Search By Partial Title', 'Search By Exact Title'] } );


        this.bgcolor = '#ff7c69';
        this.title = 'Dynamic Group';
        this.desc = 'Find a group based on ID or Title';

    }
}

module.exports = Dynamic_Group
